module.exports = __webpack_public_path__ + "img/KinokoTable44.f37eb908.jpg";